import React, { useEffect, useState } from 'react'
import Options from './OptionsUsed'
import ChangeGivenDateModal from './ChangeGivenDateModal'
import { Link } from 'react-router-dom'
import notFound from '../../../../assets/img/not-found.png'
import Api from '../../../../_helpers/Api'
import { useNotificationsContext } from '../../../../_providers/Notifications'
import checkIcon from '../../../../assets/img/icons/check.png'
import ReactTooltip from 'react-tooltip'
import { trans } from '../../../../_providers/Translation'
import DatePicker from '@/components/partials/Date'
import { Checkbox } from '@mui/material'
import { enqueueSnackbar } from 'notistack'

/**
 * Converts the displayed given date ("DD.MM.YYYY" / "DD.MM.YYYY HH:mm") to the
 * `YYYY-MM-DD` format the date picker works with.
 */
const toDateInputValue = part => {
    if (!part || !part.given_date_dmy) {
        return ''
    }

    let match = String(part.given_date_dmy).match(/^(\d{2})\.(\d{2})\.(\d{4})/)

    if (!match) {
        return ''
    }

    return `${match[3]}-${match[2]}-${match[1]}`
}

function TableUsed(props) {

    const notifications = useNotificationsContext()
    const [selectedGiveIds, setSelectedGiveIds] = useState([])
    const [giveDate, setGiveDate] = useState('')
    const [statuses, setStatuses] = useState([])
    const [loadingChangeStatus, setLoadingChangeStatus] = useState(false)
    const [loadingChangePerformer, setLoadingChangePerformer] = useState(false)
    const [givenDateModal, setGivenDateModal] = useState({
        open: false,
        id: null,
        date: '',
        loading: false
    })

    useEffect(() => {
        fetchStatuses()
    }, [])

    const setPerformer = e => {
        let val = e.target.value
        let rid = e.target.getAttribute('data-reservation-id')

        setLoadingChangePerformer(true)

        Api.post('reservations/set-performer', {
            id: Number(rid),
            employee_id: Number(val)
        })
            .then(res => {
                notifications.add(trans('messages.reservationContractorChange'))
                props.handleChangePerformer(rid, val)
            })
            .catch(() => {
                enqueueSnackbar(trans('messages.fail'), {
                    variant: 'error',
                })
            })
            .finally(() => {
                setLoadingChangePerformer(false)
            })
    }

    const setStatus = e => {
        let val = e.target.value
        let id = e.target.getAttribute('data-id')

        setLoadingChangeStatus(true)

        Api.post('ordered-parts/set-new-part-status', {
            id: Number(id),
            status_id: Number(val)
        }).then(res => {
            // notifications.add(trans('messages.reservationContractorChange'))
            props.handleChangeStatus(id, val)
            enqueueSnackbar(trans('messages.success'), {
                variant: 'success',
            })
        })
            .catch(() => {
                enqueueSnackbar(trans('messages.fail'), {
                    variant: 'error',
                })
            })
            .finally(() => {
                setLoadingChangeStatus(false)
            })
    }

    function fetchStatuses() {
        Api.get('storage/statuses').then(res => {
            setStatuses(res.data)
        })
    }

    const handleTransferAll = e => {
        if (selectedGiveIds.length) {
            Api.post('ordered-parts/transfer', {
                ids: selectedGiveIds,
                date: giveDate
            }).then(res => {
                setSelectedGiveIds([])
                setGiveDate('')
                props.handleReload()
            })
        }
    }

    const handleGiveChange = e => {
        const checked = e.target.checked

        if (checked) {
            const transferableIds = props.parts
                .filter(p => p.transferable)
                .map(p => p.id)
            setSelectedGiveIds(transferableIds)
        } else {
            setSelectedGiveIds([])
        }
    }

    const handleChangeGivenDate = id => {
        let part = props.parts.find(p => Number(p.id) === Number(id))

        setGivenDateModal({
            open: true,
            id: id,
            date: toDateInputValue(part),
            loading: false
        })
    }

    const handleCloseGivenDateModal = () => {
        setGivenDateModal(prev => ({
            ...prev,
            open: false,
            id: null,
            date: '',
            loading: false
        }))
    }

    const handleGivenDateChange = date => {
        setGivenDateModal(prev => ({
            ...prev,
            date: date
        }))
    }

    const handleSaveGivenDate = e => {
        e.preventDefault()

        if (givenDateModal.loading || !givenDateModal.date) {
            return
        }

        setGivenDateModal(prev => ({
            ...prev,
            loading: true
        }))

        Api.post('ordered-parts/reset-given-date', {
            id: Number(givenDateModal.id),
            date: givenDateModal.date
        })
            .then(() => {
                enqueueSnackbar(trans('messages.success'), {
                    variant: 'success',
                })

                handleCloseGivenDateModal()
                props.handleReload()
            })
            .catch(() => {
                enqueueSnackbar(trans('messages.fail'), {
                    variant: 'error',
                })

                setGivenDateModal(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const handleIndividualGiveChange = (e, id) => {
        setSelectedGiveIds(prev =>
            e.target.checked ? [...prev, id] : prev.filter(x => x !== id)
        )
    }

    return (

        props.parts.length === 0
            ?
            <div className="not-found">
                <img src={notFound} alt="Not Found" />
                <p>
                    {trans('messages.noResultsFound')}
                </p>
            </div>
            :
            <>
                <ChangeGivenDateModal
                    open={givenDateModal.open}
                    date={givenDateModal.date}
                    loading={givenDateModal.loading}
                    onDateChange={handleGivenDateChange}
                    onClose={handleCloseGivenDateModal}
                    onSubmit={handleSaveGivenDate}
                />

                <div className="table-scroller">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: '20px' }} className="center">
                                    <Checkbox
                                        size='small'
                                        checked={selectedGiveIds.length > 0 && selectedGiveIds.length === props.parts.filter(p => p.transferable).length}
                                        indeterminate={selectedGiveIds.length > 0 && selectedGiveIds.length < props.parts.filter(p => p.transferable).length}
                                        onChange={handleGiveChange}
                                    />
                                </th>
                                <th>ID</th>
                                <th>{trans('tables.date')}</th>


                                <th>{trans('tables.reservation')}</th>
                                {/* <th>{trans('tables.contractorCompany')}</th> */}
                                {/*
                                <th>{trans('tables.name')}</th>
                                <th>{trans('tables.supplier')}</th> */}
                                <th>{trans('tables.address')}</th>
                                <th>{trans('tables.partNumber')}</th>
                                {/* <th className="center">{trans('tables.location')}</th>
                                <th className="center">{trans('tables.quantity')}</th>
                                <th className="right">{trans('tables.grossPrice')}</th>
                                <th className="right">{trans('tables.addedOn')}</th> */}
                                <th>{trans('tables.status')}</th>
                                <th>{trans('tables.setTo')}</th>
                                <th className="options">{trans('tables.options')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.parts.map(p =>
                                <tr key={'p-' + p.id}>
                                    <td className="center">
                                        {p.transferable
                                            ?
                                            <Checkbox
                                                checked={selectedGiveIds.includes(p.id)}
                                                onChange={(e) => handleIndividualGiveChange(e, p.id)}
                                                size='small'
                                                className="give-cb"
                                            />
                                            :
                                            p.given
                                                ?
                                                <>
                                                    <img
                                                        src={checkIcon}
                                                        alt=""
                                                        height="8"
                                                        data-tip
                                                        data-for={'tooltip-p-' + p.id}
                                                    />
                                                    <ReactTooltip
                                                        id={'tooltip-p-' + p.id}
                                                        effect="solid"
                                                        backgroundColor="#ffffff"
                                                        textColor="#262f5f"
                                                        border={true}
                                                        borderColor="#e0e5f2"
                                                    >
                                                        {trans('random.givenTo')}: {p.given_date_dmy}
                                                        <br />
                                                        {trans('random.accepted')}: {p.accept_date ? trans('labels.yes') : trans('labels.no')}
                                                        <br />
                                                        {trans('random.acceptedOn')}: {p.accept_date_dmy || 'n/a'}
                                                        <br />
                                                    </ReactTooltip>
                                                </>
                                                :
                                                ''
                                        }
                                    </td>
                                    <td>
                                        {p.id}
                                    </td>
                                    <td>
                                        {p.add_date}
                                    </td>

                                    <td>
                                        {p.reservation ?
                                            <a
                                                href={`/reservations/edit/${p.reservation.id}?tab=parts`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            // className="btn"
                                            // style={{ background: p.reservation.color, color: p.reservation.text_color }}
                                            >
                                                {p.reservation.reference_code} (ID: {p.reservation_id})
                                            </a>
                                            :
                                            '-'}
                                    </td>
                                    {/* 
                                    <td>
                                        {p.reservation && p.reservation.contractor
                                            ?
                                            p.reservation.contractor.name
                                            :
                                            ''
                                        }
                                    </td> */}

                                    {/*
                                    <td>
                                        {p.name}
                                    </td>
                                    <td>
                                        {p.supplier ? p.supplier.name : ''}
                                        <br />
                                        {p.po_number ? `PO: ${p.po_number}` : ''}
                                    </td> */}

                                    <td>

                                        {p.reservation
                                            ?
                                            <>
                                                <span
                                                    data-tip
                                                    data-for={'rs-' + p.id}
                                                >
                                                    {(p.reservation.full_address || '').substring(0, 6)}
                                                </span>


                                                <ReactTooltip
                                                    id={'rs-' + p.id}
                                                    effect="solid"
                                                >
                                                    {p.reservation.full_address}
                                                </ ReactTooltip>
                                            </>
                                            :
                                            ''
                                        }

                                    </td>

                                    <td>
                                        {p.number}
                                    </td>
                                    {/* <td className="center">
                                        {p.total_quantity > 0 ? trans('random.inStock') : trans('random.noStock')}
                                    </td>
                                    <td className="center">
                                        {p.quantity}
                                    </td>
                                    <td className="right">{p.gross_price_format} {p.currency.name}</td>
                                    <td className="right">{p.add_date}</td> */}
                                    <td>
                                        <select
                                            data-id={p.id}
                                            style={{
                                                width: '100px',
                                                backgroundColor: "#f8f8ff",
                                                borderRadius: "20px",
                                                height: "30px",
                                                border: "none"
                                            }}
                                            value={p.status?.id || ''}
                                            onChange={setStatus}
                                            disabled={loadingChangeStatus}
                                        >
                                            {statuses.map((status, i) =>
                                                <option
                                                    key={'status-' + status.id}
                                                    value={Number(status.id)}
                                                >
                                                    {status.name}
                                                </option>
                                            )}
                                        </select>
                                    </td>

                                    <td>

                                        <select
                                            data-reservation-id={p.reservation_id}
                                            style={{
                                                width: '100px',
                                                backgroundColor: "#f8f8ff",
                                                borderRadius: "20px",
                                                height: "30px",
                                                border: "none"
                                            }}
                                            value={p.reservation && p.reservation.employee_id ? Number(p.reservation.employee_id) : ''}
                                            onChange={setPerformer}
                                            disabled={loadingChangePerformer}
                                        // disabled={p.position.name === 'van'}
                                        >
                                            <option value="" disabled></option>
                                            {props.performers.map((performer, i) =>
                                                <option
                                                    key={'performer-' + i}
                                                    value={Number(performer.id)}
                                                >
                                                    {performer.type === 'App\\Employee' || performer.type === 'App\\Models\\Employee'
                                                        ?
                                                        `${performer.name} ${performer.lastname}`
                                                        :
                                                        performer.name
                                                    }

                                                </option>
                                            )}
                                        </select>

                                    </td>
                                    <td>
                                        <Options
                                            id={p.id}
                                            deletable={p.deletable}
                                            editable={p.editable}
                                            handleEdit={props.handleEdit}
                                            handleDelete={props.handleDelete}
                                            handleHistory={props.handleHistory}
                                            handleChangeGivenDate={handleChangeGivenDate}
                                            isGiven={p.given}
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div >
                <hr />
                <div className="actions">
                    <DatePicker
                        id="give-date"
                        withTime
                        date={giveDate}
                        onDateChange={(date) => setGiveDate(date || '')}
                        disabled={!selectedGiveIds.length}
                    />
                    <button
                        onClick={handleTransferAll}
                        disabled={!selectedGiveIds.length}
                    >
                        {trans("random.markUp")}
                    </button>

                </div>

            </>
    )
}

export default TableUsed